import { Component, Output, EventEmitter, OnDestroy, Renderer2, Inject, OnInit, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { BehaviorSubject, delay, tap } from 'rxjs';

@Component({
  selector: 'peca-dialog',
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.scss',
  imports: [],
})
export class DialogComponent implements OnInit, OnDestroy {
  renderer = inject(Renderer2);
  document = inject(DOCUMENT);
  open$ = new BehaviorSubject<boolean>(false);
  active = false;
  ready = false;

  close() {
    this.open$.next(false);
  }

  open() {
    this.open$.next(true);
  }

  ngOnInit() {
    this.open$
      .pipe(
        tap((opt) => {
          if (opt) {
            this.active = opt;
            this.renderer.addClass(this.document.body, 'dialog-hidden-scroll');
          } else {
            this.ready = opt;
          }
        }),
        delay(128)
      )
      .subscribe((opt) => {
        if (!opt) {
          this.active = opt;
          this.renderer.removeClass(this.document.body, 'dialog-hidden-scroll');
        } else {
          this.ready = opt;
        }
      });
  }

  ngOnDestroy() {
    this.open$.unsubscribe();
  }

  onClickClose() {
    this.open$.next(false);
  }
}
